<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :label="$t('search_address')"
          v-model="searchAddress"
          color="secondary"
          hide-details
        >
          <template v-slot:append-outer>
            <v-btn
              @click="execSearchAddress"
              color="primary"
              class="mt-n2"
              elevation="1"
              fab
              small
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6" cols="12">
        <v-text-field
          v-if="coordinates && showCoordinates == 'true'"
          disabled
          v-model="coordinates.coordX"
          :label="$t('latitude')"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col md="6" cols="12">
        <v-text-field
          v-if="coordinates && showCoordinates == 'true'"
          disabled
          v-model="coordinates.coordY"
          :label="$t('longitude')"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    <div class="mapContainer">
      <l-map
        v-if="marker"
        ref="map"
        :zoom="mapZoom"
        :center="marker"
        :options="mapOptions"
        style="height: 100%"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker
          :lat-lng="marker"
          :draggable="draggable"
          @moveend="updateCoordinates"
          :icon="myIcon"
        >
          <l-icon
            icon-url="null"
            icon-shadow-url="null"
            :icon-size="iconSize"
            :icon-anchor="iconAnchor"
          >
            <v-icon size="50" color="primary">mdi-map-marker</v-icon>
          </l-icon>
        </l-marker>
      </l-map>
    </div>
  </v-container>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import { OpenStreetMapProvider } from "leaflet-geosearch";

export default {
  name: "select-on-map",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },
  props: {
    showCoordinates: {
      type: String,
      default: "true",
    },
    coordX: {
      type: Number,
      default: null,
    },
    coordY: {
      type: Number,
      default: null,
    },
    zoom: {
      type: Number,
      default: 13,
    },
  },
  data() {
    return {
      myIcon: L.icon({
        iconUrl: "null",
        shadowUrl: "null",

        iconSize: [50, 50], // size of the icon
        shadowSize: [50, 64], // size of the shadow
        iconAnchor: [16, 37], // point of the icon which will correspond to marker's location
        shadowAnchor: [4, 62], // the same for the shadow
        popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
      }),
      draggable: true,
      searchAddress: null,
      mapZoom: this.zoom,
      marker: null,
      coordinates: { lat: this.coordX, lng: this.coordY },
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5,
      },
      iconSize: [50, 50],
      iconAnchor: [16, 37],
    };
  },
  mounted() {
    loadMap();
  },
  watch: {
    coordX: function (newVal, oldVal) {
      this.loadMap();
    },
    coordY: function (newVal, oldVal) {
      this.loadMap();
    },
  },
  methods: {
    loadMap() {
      let _ = this;
      _.searchAddress = "";
      if (_.coordX && _.coordY) {
        _.updateResponse(_.coordX, _.coordY);
      } else {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (geoLocate) {
            _.updateResponse(
              geoLocate.coords.latitude,
              geoLocate.coords.longitude
            );
          });
        } else {
          _._data.marker = latLng(0, 0);
          _._data.coordinates = null;
        }
      }
    },
    updateResponse(coordX, coordY) {
      let _ = this;
      _._data.marker = latLng(coordX, coordY);
      _._data.coordinates.coordX = coordX;
      _._data.coordinates.coordY = coordY;
      this.$emit("coordinates", _._data.coordinates);
    },
    execSearchAddress() {
      let _ = this;
      const provider = new OpenStreetMapProvider();
      provider.search({ query: _._data.searchAddress }).then(
        (value) => {
          // Success!
          _.updateResponse(value[0].y, value[0].x);
          _._data.searchAddress = value[0].label;
        },
        (reason) => {
          console.log(reason); // Error!
        }
      );
    },
    updateCoordinates(location) {
      this.updateResponse(
        location.target._latlng.lat,
        location.target._latlng.lng
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.mapContainer {
  height: calc(100% - 150px);
  width: 100%;
  .leaflet-container {
    z-index: 0;
  }
}
</style>
